import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";

/**
 * DefaultCheckBox
 */

type Props = {
  name: string;
  label?: string;
  readonly?: boolean;
  required?: boolean;
  disabled?: boolean;
  value?: boolean;
  onChangeValue?: (newValue: boolean) => void;
};

export const DefaultCheckBox = ({
  name,
  label,
  readonly,
  required,
  disabled,
  value,
  onChangeValue,
}: Props) => {
  return (
    <FormGroup>
      <FormControlLabel
        name={name}
        label={<span className="text-sm text-black dark:text-white">{label}</span>}
        required={required}
        disabled={disabled}
        control={
          <Checkbox
            checked={value as any}
            onChange={e => {
              if (!readonly) onChangeValue?.(e.target.checked);
            }}
          />
        }
      />
    </FormGroup>
  );
}